import { render, staticRenderFns } from "./vipAllocationEdit.vue?vue&type=template&id=d73e02f0"
import script from "./vipAllocationEdit.vue?vue&type=script&lang=js"
export * from "./vipAllocationEdit.vue?vue&type=script&lang=js"
import style0 from "./vipAllocationEdit.vue?vue&type=style&index=0&id=d73e02f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports